import { ConsentRecontactLegal, FieldCheckbox, FieldInput, Question } from '@workspace/core-ts/components';
import { useGlobalForm } from '@workspace/core-ts/contexts';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { CarteGrise, OrdinateurTchat, TelephoneTchat } from '@workspace/core-ts/icons-amo';
import contactContent from '../content/6-information-contact';
import type { FormSchemaType } from '../schema';

export default function InformationContact() {
    const methods = useSmartFormGlobal<FormSchemaType>();
    const {
        actions: { getContent },
    } = useGlobalForm();

    const handleSubmit = async (data: FormSchemaType) => {
        const Personne = data.DemandeTarif.ListePersonnes?.[0];
        if (!Personne) return;

        return {
            ...data,
            DemandeContrat: {
                ...data.DemandeContrat,
                SignatureEmail: Personne.Email,
                SignaturePhone: Personne.TelPortable,
            },
        };
    };

    return (
        <SmartFormGlobal {...methods} className="mx-auto" onSubmit={handleSubmit}>
            <Question buttonLabel="Allons-y !" className="text-center max-w-3xl">
                <CarteGrise />
                <Question.Title className="max-w-lg">
                    <b>C'est bon</b>, nous avons <b>toutes les informations</b> qu'il nous faut !
                </Question.Title>

                <Question.Description>
                    <p>Finissons avec vos coordonnées !</p>
                    <p>
                        Nous en avons besoin pour <b>vous transmettre votre devis personnalisé</b> et <b>vous accompagnez au mieux</b> dans vos démarches.
                    </p>
                </Question.Description>

                <p className="font-medium text-secondary text-lg sm:text-xl mb-8">OK pour vous ?</p>
            </Question>

            <Question className="max-w-lg" disabledButton={!methods.formState.isValid}>
                <Question.Header>
                    <OrdinateurTchat />
                    <Question.Title>
                        Quelle est votre <b>adresse e-mail</b> ?
                    </Question.Title>
                </Question.Header>
                <FieldInput
                    autoComplete="email"
                    description={getContent(contactContent.descriptionEmail) as string}
                    name="DemandeTarif.ListePersonnes.0.Email"
                    type="email"
                    validation={{
                        pattern: {
                            value: /\S+@\S+\.\S+/,
                            message: 'Adresse e-mail invalide',
                        },
                    }}
                />
            </Question>

            <Question className="max-w-lg" disabledButton={!methods.formState.isValid}>
                <Question.Header>
                    <TelephoneTchat />
                    <Question.Title>
                        Quel est votre <b>numéro de téléphone</b> ?
                    </Question.Title>
                </Question.Header>

                <FieldInput
                    autoComplete="tel"
                    name="DemandeTarif.ListePersonnes.0.TelPortable"
                    placeholder="Exemple : 06 07 08 09 10"
                    validation={{
                        pattern: {
                            value: /^0[1-9]([-. ]?[0-9]{2}){4}$/,
                            message: 'Numéro de téléphone invalide',
                        },
                        setValueAs: (value: string) => value?.replace(/\D/g, ''),
                    }}
                />

                <FieldCheckbox
                    label="Afin d'être accompagné dans le cadre de ma démarche d'assurance, j'accepte qu’un expert moto me contacte par téléphone."
                    name="DemandeTarif.ListePersonnes.0.AccepteSms"
                />
                <ConsentRecontactLegal className="text-xs" />
            </Question>
        </SmartFormGlobal>
    );
}
